import React, { useEffect } from 'react';
import { globalShortcutsService } from '../services/globalShortcutsService';
import GlobalEntitySearch from '../components/Space/GlobalEntitySearch/GlobalEntitySearch';
import { useGlobalEntitySearchStore } from '../stores/globalEntitySearchStore';

const isOnHomeRoute = (): boolean => {
  const path = window.location.pathname;
  return path === '/home' || path === '/' || path.startsWith('/home/');
};

export const useGlobalEntitySearchShortcut = () => {
  const { isOpen, toggle, close } = useGlobalEntitySearchStore();

  useEffect(() => {
    globalShortcutsService.register({
      id: 'global_entity_search',
      key: 'k',
      modifiers: { cmd: true },
      description: 'Open global search',
      handler: () => {
        // The global search modal sources from the active space's cache; on
        // Home there is no active space so the shortcut is a no-op. The Home
        // sidebar's Search button still opens the modal (backend search for
        // cross-space lookup).
        if (isOnHomeRoute()) return;
        toggle();
      },
    });

    return () => globalShortcutsService.unregister('global_entity_search');
  }, [toggle]);

  const GlobalEntitySearchModal = isOpen
    ? <GlobalEntitySearch onClose={close} />
    : null;

  return { GlobalEntitySearchModal };
};
